import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import AboutusBG from "../../Assets/AboutUs_Img/about_background_img.webp";
import CredentialsSupremacyImage1 from "../../Assets/image/image4.webp";
import CredentialsSupremacyImage2 from "../../Assets/image/image7.webp";
import our_products_1 from "../../Assets/image/image14.webp";
import our_products_2 from "../../Assets/image/image16.webp";
import image2 from "../../Assets/image1.jpg";
import image1 from "../../Assets/image2.jpg";
import api, { PUBLIC_BASE_URL } from "../../api/api";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

const AboutUs = () => {
  // const [banner, setBanner] = useState(null);

  // useEffect(() => {
  //   NProgress.start();
  //   api
  //     .get("/aboutusbanner")
  //     .then((res) => {
  //       console.log("AboutUs Banner Response:", res.data);
  //       if (res.data.length > 0) {
  //         setBanner(res.data[0]);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Failed to load banner", err);
  //     })
  //     .finally(() => {
  //       NProgress.done();
  //       setLoading(false);
  //     });
  // }, []);

  // NProgress.configure({ showSpinner: false, trickleSpeed: 200 });
  // const [loading, setLoading] = useState(true);
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    NProgress.start();
    api
      .get("/aboutusbanner")
      .then((res) => {
        if (res.data.length > 0) {
          setBanners(res.data); // Set all banners
        }
      })
      .catch((err) => {
        console.error("Failed to load banner", err);
      })
      .finally(() => {
        NProgress.done();
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval); // Cleanup
  }, [banners.length]);

  const currentBanner = banners[currentIndex];

  const directors = [
    {
      name: "Mr. Niraj Patel",
      title: "Co-Founder & Director",
      description: `Mr. Niraj Patel holds a Master of Science in Chemistry. He began his career as a pharma trainee with Cambridge Health Care Ltd, partnered with Shashi Pharmaceutical, and founded "Khodiyar Industries" in 2009. He is also a partner in Khodiyar Corporation, involved in decorative glass and glass crushing since 2010.`,
      image: image1, // update path if stored locally
    },
    {
      name: "Mr. Laxmanbhai Patel",
      title: "Co-Founder & Director",
      description: `Mr. Laxmanbhai Patel completed his H.S.C. education. He started his career in the oil trading business.  Later, he shifted to brick manufacturing.  He founded Khodiyar Bricks in 2001.  He established Jay Khodiyar Bricks in 2014.  With over 20 years of experience, he brings strong leadership to the company.`,
      image: image2, // reuse image or use a different one
    },
  ];

  const [index, setIndex] = useState(0);

  const handleNext = () => setIndex((index + 1) % directors.length);
  const handlePrev = () =>
    setIndex((index - 1 + directors.length) % directors.length);

  const { name, title, description, image } = directors[index];

  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid about_banner fade-transition"
        style={{
          background: currentBanner?.image
            ? `url(${PUBLIC_BASE_URL}${currentBanner.image}) center center / cover no-repeat`
            : "none",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h1>{currentBanner?.title || "ABOUT US"}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* banner section end */}

      {/* about tabbing section start  */}
      <section
        className="container-fluid about_Products_section py-5"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <div className="container">
          <div className="row g-5 align-items-start">
            {/* Left Section */}
            <div className="col-lg-8 col-md-12">
              <div className="blog_text wow fadeInUp mb-4">
                <h2
                  className="mb-3"
                  style={{ fontWeight: "700", color: "#5b9cdd" }}
                >
                  Our Products
                </h2>
                <p className="mb-3">
                  Incorporated in{" "}
                  <strong style={{ color: "#5b9cdd" }}>2015</strong> at Mehsana
                  (Gujarat, India),{" "}
                  <strong style={{ color: "#5b9cdd" }}>
                    Khodiyar Industries
                  </strong>{" "}
                  is a leading manufacturer and supplier of high-quality
                  automobile and commercial vehicle glass under the brand name{" "}
                  <strong style={{ color: "#5b9cdd" }}>Khodiyar India</strong>.
                  We specialize in Automotive Toughened Glass, Automotive
                  Toughened Glass, Tempered Glass, and more.
                </p>
                <p className="mb-3">
                  Our glasses are precisely crafted using premium silicon and
                  meet strict industry standards. They are known for exceptional
                  features like abrasion and scratch resistance. We offer
                  customized glass solutions tailored to the unique needs of our
                  clients at competitive prices.
                </p>
                <p className="mb-3">
                  Backed by a modern in-house production unit and quality-driven
                  operations, we guarantee excellent finish and performance.
                  Under the guidance of{" "}
                  <strong style={{ color: "#5b9cdd" }}>
                    Mr. Niraj Patel & Mr. Laxman Patel{" "}
                  </strong>
                  , we’ve built a strong client base across India and are
                  committed to timely delivery and client satisfaction.
                </p>
              </div>
              <div className="row">
                <div className="col-6">
                <div className="Products_img wow fadeInUp">
                <img
                  src={our_products_1}
                  alt="Our Products"
                  className="img-fluid rounded shadow-sm"
                  style={{width: "250px" , height: "400px"}}
                />
              </div>
                </div>
                <div className="col-6">
                <div className="Products_img wow fadeInUp">
                <img
                  src={our_products_2}
                  alt="Our Products"
                  className="img-fluid rounded shadow-sm"
                  style={{width: "250px" , height: "400px"}}
                />
              </div>
                </div>


              </div>

            </div>

            {/* Right Side Links */}
            <div className="col-lg-4 col-md-12">
              <div
                className="right_side wow fadeInUp p-4 rounded shadow-sm"
                style={{ backgroundColor: "#ffffff" }}
              >
                <h4
                  className="mb-4 text-center"
                  style={{ fontWeight: "600", color: "#5b9cdd" }}
                >
                  Explore Our Product Range
                </h4>
                <ul className="services_text list-unstyled ps-2">
                  <li className="mb-3">
                    <Link
                      to="/Window_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Window Glass
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link
                      to="/Car_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Car Glass
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link
                      to="/E_Rickshaw_Spare_Parts_Glass"
                      className="text-decoration-none text-dark"
                    >
                      E Rickshaw Glass
                    </Link>
                  </li>
                  {/* <li className="mb-3">
                    <Link
                      to="/Automotive_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Automotive Glass
                    </Link>
                  </li> */}
                  <li className="mb-3">
                    <Link
                      to="/Commercial_Vehicle_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Commercial Vehicle Glass
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link
                      to="/Automobile_Toughness_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Automotive Toughened Glass
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/Construction_Equipment_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Road & Construction Equipment Glass
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/Automative_Laminated_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Automotive Laminated Glass
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/Arctitecture_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Arctitecture Glass
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/Home_Appliance_glasses"
                      className="text-decoration-none text-dark"
                    >
                      Home Appliance glasses
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/Railway_Window_Glass"
                      className="text-decoration-none text-dark"
                    >
                      Railway Window Glass
                    </Link>
                  </li>

                  <li className="mb-3">
                    <Link
                      to="/DGU_Glass"
                      className="text-decoration-none text-dark"
                    >
                      DGU Glass
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <div
        className="slider-hero fade-transition "
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
        }}
      >
        <div className="slider-hero-overlay ">
          <div className="slider-text-box ">
            <h3>Our Leadership</h3>
            <h1>{name}</h1>
            <h4>{title}</h4>
            <p>{description}</p>
          </div>
        </div>
        <div className="slider-nav">
          <button onClick={handlePrev}>←</button>
          <button onClick={handleNext}>→</button>
        </div>
      </div>

      {/* Credentials & Supremacy section start  */}
      <section className="container-fluid supremacy_section py-5">



        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <h2 className="section-title">Credentials & Supremacy</h2>
            </div>
          </div>

          {/* First Row: Image on Right and Content on Left */}
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <ul className="credentials-list">
                    <li>
                      <strong>MSME</strong> – Ministry of Micro, Small & Medium
                      Enterprise
                    </li>
                    <li>
                      <strong>BIS</strong> – Bureau of Indian Standards (ISI)
                    </li>
                    <li>
                      <strong>GEM</strong> – Government e-Marketplace
                    </li>
                    <li>
                      <strong>DGQA</strong> – Directorate General of Quality
                      Assurance
                    </li>
                    <li>
                      <strong>BSI</strong> – British Standards Institution (ISO
                      9001:2008)
                    </li>
                    <li>
                      <strong>ARAI</strong> – Automotive Research Association of
                      India
                    </li>
                    <li>
                      <strong>IATF</strong> – International Automotive Task
                      Force (16949 D)
                    </li>
                  </ul>
                </div>
              </div>
            </div>




            {/* Right Side - Image */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="  border-0">
                <div className="mt-5 text-center">
                  <img
                    src={CredentialsSupremacyImage1}
                    alt="Supremacy Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>

 {/* ISO Certifications */}
 <div className="row mt-5 mb-5">
  <div className="col-12 text-center">
    <h4 className="iso-title mb-4">ISO Certifications</h4>
    <div className="iso-certifications d-flex flex-wrap justify-content-center gap-4">
      <span className="iso-badge">ISO 9001:2015</span>
      <span className="iso-badge">ISO 14001:2015</span>
      <span className="iso-badge">ISO 45001:2018</span>
    </div>
  </div>
</div>


          {/* Second Row: Image on Left and Content on Right */}
          <div className="row mt-5">
            <div className="col-lg-6 col-md-12 col-sm-12 order-lg-2 order-1">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <ul className="credentials-list">
                    <li>
                      <strong>CIRT</strong> – Central Institute of Road
                      Transport, Pune
                    </li>
                    <li>
                      <strong>ASRTU</strong> – Association of State Road
                      Transport Undertakings
                    </li>
                    <li>
                      <strong>ICAT</strong> – International Centre for
                      Automotive Technology
                    </li>
                    <li>
                      <strong>TBRL</strong> – Terminal Ballistic Research
                      Laboratory
                    </li>
                    <li>
                      <strong>GFSU</strong> – Gujarat Forensic Sciences
                      University
                    </li>
                    <li>
                      <strong>E-Mark</strong> – Certification for Exports
                    </li>
                    <li>
                      <strong>Tuv Nord</strong> – Certification
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Right Side - Credentials Content */}
            <div className="col-lg-6 col-md-12 col-sm-12 order-lg-1 order-2">
              <div className="mt-5 border-0">
                <div className=" text-center">
                  <img
                    src={CredentialsSupremacyImage2}
                    alt="Supremacy Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>




      </section>

      {/* Credentials & Supremacy section End  */}

      <Footer />
    </div>
  );
};

export default AboutUs;
